/* eslint-disable */
export default {
  _more_assets_Background: 'more-assets/Background',
  _more_assets_EndBackground: 'more-assets/EndBackground',
  _game_assets_ZipperBg: 'game-assets/ZipperBg',
  _game_assets_WorkAreaBg: 'game-assets/WorkAreaBg',
  _game_assets_arrows: 'game-assets/arrows',
  _backpack_backpackstyle1_FILL_full_backpack: 'backpack/backpackstyle1/FILL_full_backpack',
  _backpack_backpackstyle3_OUTLINE_main: 'backpack/backpackstyle3/OUTLINE_main',
  _backpack_backpackstyle2_OUTLINE_pocket_bottom: 'backpack/backpackstyle2/OUTLINE_pocket_bottom',
  _backpack_backpackstyle3_FILL_strap_vertical: 'backpack/backpackstyle3/FILL_strap_vertical',
  _game_assets_PATTERN_7: 'game-assets/PATTERN+7',
  _game_assets_PATTERN_2: 'game-assets/PATTERN+2',
  _backpack_backpackstyle3_OUTLINE_strap_horizontal: 'backpack/backpackstyle3/OUTLINE_strap_horizontal',
  _backpack_backpackstyle3_FILL_handle_bottom: 'backpack/backpackstyle3/FILL-handle-bottom',
  _more_assets_hook_front: 'more-assets/hook_front',
  _more_assets_menu_bar: 'more-assets/menu_bar',
  _backpack_backpackstyle4_FILL_metal_ring: 'backpack/backpackstyle4/FILL_metal_ring',
  _backpack_backpackstyle4_ring_left: 'backpack/backpackstyle4/ring_left',
  _backpack_backpackstyle4_ring_right: 'backpack/backpackstyle4/ring_right',
  _backpack_backpackstyle3_metal_left: 'backpack/backpackstyle3/metal-left',
  _backpack_backpackstyle3_OUTLINE_strap_vertical: 'backpack/backpackstyle3/OUTLINE_strap_vertical',
  _game_assets_PATTERN_3: 'game-assets/PATTERN+3',
  _game_assets_ICON_rotate: 'game-assets/ICON_rotate',
  _game_assets_MENU_backpack: 'game-assets/MENU_backpack',
  _game_assets_KEYCHAIN_9: 'game-assets/KEYCHAIN+9',
  _game_assets_PATTERN_9: 'game-assets/PATTERN+9',
  _game_assets_BUTTON_arrow_left: 'game-assets/BUTTON_arrow_left',
  _game_assets_BUTTON_arrow_left_glow: 'game-assets/BUTTON_arrow_left_glow',
  _game_assets_BUTTON_arrow_right: 'game-assets/BUTTON_arrow_right',
  _game_assets_BUTTON_arrow_right_glow: 'game-assets/BUTTON_arrow_right_glow',
  _game_assets_MenuStrip: 'game-assets/MenuStrip',
  _backpack_backpackstyle1_OUTLINE_pocket_front: 'backpack/backpackstyle1/OUTLINE_pocket_front',
  _backpack_backpackstyle2_FILL_pocket_bottom: 'backpack/backpackstyle2/FILL_pocket_bottom',
  _backpack_backpackstyle1_zipper: 'backpack/backpackstyle1/zipper',
  _backpack_backpackstyle3_metal_right: 'backpack/backpackstyle3/metal-right',
  _backpack_backpackstyle3_OUTLINE_backpack_top_flap: 'backpack/backpackstyle3/OUTLINE_backpack_top_flap',
  _backpack_backpackstyle2_buckle2: 'backpack/backpackstyle2/buckle2',
  _backpack_backpackstyle1_OUTLINE_pocket_left: 'backpack/backpackstyle1/OUTLINE_pocket_left',
  _backpack_backpackstyle1_OUTLINE_pocket_right: 'backpack/backpackstyle1/OUTLINE_pocket_right',
  _game_assets_ZipperClosed: 'game-assets/ZipperClosed',
  _backpack_backpackstyle1_FILL_pocket_left: 'backpack/backpackstyle1/FILL_pocket_left',
  _backpack_backpackstyle1_FILL_pocket_right: 'backpack/backpackstyle1/FILL_pocket_right',
  _backpack_backpackstyle1_FILL_handle_top: 'backpack/backpackstyle1/FILL-handle-top',
  _backpack_backpackstyle1_OUTLINE_handle_top: 'backpack/backpackstyle1/OUTLINE-handle-top',
  _backpack_backpackstyle2_OUTLINE_pocket_top_flap: 'backpack/backpackstyle2/OUTLINE_pocket_top_flap',
  _backpack_backpackstyle2_FILL_pocket_top_flap: 'backpack/backpackstyle2/FILL_pocket_top_flap',
  _backpack_backpackstyle4_FILL_strap_bottom_left: 'backpack/backpackstyle4/FILL_strap_bottom_left',
  _game_assets_ZipperPull: 'game-assets/ZipperPull',
  _game_assets_dots: 'game-assets/dots',
  _more_assets_IntroBackpack: 'more-assets/IntroBackpack',
  _game_assets_stripes: 'game-assets/stripes',
  _backpack_backpackstyle3_FILL_full_backpack: 'backpack/backpackstyle3/FILL_full_backpack',
  _backpack_backpackstyle2_FILL_full_backpack: 'backpack/backpackstyle2/FILL_full_backpack',
  _backpack_backpackstyle3_OUTLINE_handle_left_top: 'backpack/backpackstyle3/OUTLINE-handle-left-top',
  _backpack_backpackstyle1_OUTLINE_main: 'backpack/backpackstyle1/OUTLINE_main',
  _game_assets_PATTERN_1: 'game-assets/PATTERN+1',
  _backpack_backpackstyle3_FILL_handle_left_top: 'backpack/backpackstyle3/FILL-handle-left-top',
  _backpack_backpackstyle2_OUTLINE_backpack_top_flap: 'backpack/backpackstyle2/OUTLINE_backpack_top_flap',
  _backpack_backpackstyle4_FILL_strap_top_left: 'backpack/backpackstyle4/FILL_strap_top_left',
  _backpack_backpackstyle4_OUTLINE_main: 'backpack/backpackstyle4/OUTLINE_main',
  _backpack_backpackstyle3_FILL_backpack_top_flap: 'backpack/backpackstyle3/FILL_backpack_top_flap',
  _game_assets_PATTERN_4: 'game-assets/PATTERN+4',
  _backpack_backpackstyle1_FILL_pocket_front: 'backpack/backpackstyle1/FILL_pocket_front',
  _backpack_backpackstyle2_FILL_backpack_top_flap: 'backpack/backpackstyle2/FILL_backpack_top_flap',
  _backpack_backpackstyle4_FILL_full_backpack: 'backpack/backpackstyle4/FILL_full_backpack',
  _game_assets_BACKPACK_4: 'game-assets/BACKPACK+4',
  _backpack_backpackstyle2_buckle: 'backpack/backpackstyle2/buckle',
  _game_assets_PATTERN_10: 'game-assets/PATTERN+10',
  _game_assets_ZipperOpen: 'game-assets/ZipperOpen',
  _game_assets_KEYCHAIN_11: 'game-assets/KEYCHAIN+11',
  _game_assets_PATTERN_6: 'game-assets/PATTERN+6',
  _game_assets_PATCH_33: 'game-assets/PATCH+33',
  _game_assets_PATTERN_11: 'game-assets/PATTERN+11',
  _game_assets_PATTERN_8: 'game-assets/PATTERN+8',
  _game_assets_KEYCHAIN_6: 'game-assets/KEYCHAIN+6',
  _game_assets_PATTERN_5: 'game-assets/PATTERN+5',
  _game_assets_BTN_0: 'game-assets/BTN+0',
  _backpack_backpackstyle3_FILL_strap_horizontal: 'backpack/backpackstyle3/FILL_strap_horizontal',
  _game_assets_KEYCHAIN_3: 'game-assets/KEYCHAIN+3',
  _game_assets_COLORS_paint_swatch_outline: 'game-assets/COLORS_paint_swatch_outline',
  _game_assets_BUTTON_done: 'game-assets/BUTTON_done',
  _game_assets_COLORS_paint_swatch: 'game-assets/COLORS_paint_swatch',
  _game_assets_BTN_1: 'game-assets/BTN+1',
  _game_assets_KEYCHAIN_4: 'game-assets/KEYCHAIN+4',
  _backpack_backpackstyle2_handle: 'backpack/backpackstyle2/handle',
  _game_assets_PATCH_28: 'game-assets/PATCH+28',
  _game_assets_KEYCHAIN_10: 'game-assets/KEYCHAIN+10',
  _backpack_backpackstyle3_OUTLINE_handle_left_bottom: 'backpack/backpackstyle3/OUTLINE-handle-left-bottom',
  _game_assets_ChainHoop: 'game-assets/ChainHoop',
  _backpack_backpackstyle4_FILL_strap_bottom_right: 'backpack/backpackstyle4/FILL_strap_bottom_right',
  _backpack_backpackstyle3_buckle: 'backpack/backpackstyle3/buckle',
  _game_assets_KEYCHAIN_8: 'game-assets/KEYCHAIN+8',
  _backpack_backpackstyle4_OUTLINE_pocket_left: 'backpack/backpackstyle4/OUTLINE_pocket_left',
  _game_assets_KEYCHAIN_5: 'game-assets/KEYCHAIN+5',
  _game_assets_PATCH_38: 'game-assets/PATCH+38',
  _game_assets_BACKPACK_1: 'game-assets/BACKPACK+1',
  _backpack_backpackstyle4_FILL_strap_right_top: 'backpack/backpackstyle4/FILL_strap_right_top',
  _backpack_backpackstyle4_FILL_strap_top_right: 'backpack/backpackstyle4/FILL_strap_top_right',
  _game_assets_BACKPACK_3: 'game-assets/BACKPACK+3',
  _game_assets_PATCH_30: 'game-assets/PATCH+30',
  _game_assets_PATCH_37: 'game-assets/PATCH+37',
  _game_assets_PATTERNS_button_3: 'game-assets/PATTERNS_button+3',
  _backpack_backpackstyle3_OUTLINE_handle_bottom: 'backpack/backpackstyle3/OUTLINE-handle-bottom',
  _backpack_backpackstyle1_OUTLINE_handle_bottom: 'backpack/backpackstyle1/OUTLINE-handle-bottom',
  _backpack_backpackstyle3_FILL_handle_left_bottom: 'backpack/backpackstyle3/FILL-handle-left-bottom',
  _backpack_backpackstyle3_OUTLINE_handle_right_bottom: 'backpack/backpackstyle3/OUTLINE-handle-right-bottom',
  _backpack_backpackstyle4_FILL_main: 'backpack/backpackstyle4/FILL_main',
  _backpack_backpackstyle2_OUTLINE_main: 'backpack/backpackstyle2/OUTLINE_main',
  _game_assets_BTN_2: 'game-assets/BTN+2',
  _game_assets_BTN_3: 'game-assets/BTN+3',
  _game_assets_MENU_colors: 'game-assets/MENU_colors',
  _game_assets_MENU_patches: 'game-assets/MENU_patches',
  _game_assets_MENU_patterns: 'game-assets/MENU_patterns',
  _game_assets_MENU_keychains: 'game-assets/MENU_keychains',
  _game_assets_PATCH_27: 'game-assets/PATCH+27',
  _backpack_backpackstyle1_FILL_handle_bottom: 'backpack/backpackstyle1/FILL-handle-bottom',
  _game_assets_PATCH_32: 'game-assets/PATCH+32',
  _game_assets_PATCH_34: 'game-assets/PATCH+34',
  _game_assets_KEYCHAIN_7: 'game-assets/KEYCHAIN+7',
  _game_assets_PATCH_29: 'game-assets/PATCH+29',
  _game_assets_KEYCHAIN_2: 'game-assets/KEYCHAIN+2',
  _game_assets_PATCH_36: 'game-assets/PATCH+36',
  _game_assets_BACKPACK_2: 'game-assets/BACKPACK+2',
  _more_assets_BTN_Play: 'more-assets/BTN_Play',
  _game_assets_KEYCHAIN_1: 'game-assets/KEYCHAIN+1',
  _game_assets_PATCH_35: 'game-assets/PATCH+35',
  _game_assets_PATCH_31: 'game-assets/PATCH+31',
  _game_assets_PATTERNS_button_1: 'game-assets/PATTERNS_button+1',
  _more_assets_IntroPatch_1: 'more-assets/IntroPatch+1',
  _game_assets_PATTERNS_button_2: 'game-assets/PATTERNS_button+2',
  _more_assets_IntroPath_3: 'more-assets/IntroPath+3',
  _game_assets_PATTERNS_button_4: 'game-assets/PATTERNS_button+4',
  _game_assets_PATTERNS_button_5: 'game-assets/PATTERNS_button+5',
  _game_assets_PATTERNS_button_6: 'game-assets/PATTERNS_button+6',
  _game_assets_COLOR_fill_1: 'game-assets/COLOR_fill+1',
  _game_assets_PATTERNS_button_7: 'game-assets/PATTERNS_button+7',
  _game_assets_PATTERNS_button_8: 'game-assets/PATTERNS_button+8',
  _game_assets_COLOR_fill_2: 'game-assets/COLOR_fill+2',
  _game_assets_COLOR_fill_glow: 'game-assets/COLOR_fill_glow',
  _backpack_backpackstyle4_OUTLINE_pocket_right: 'backpack/backpackstyle4/OUTLINE_pocket_right',
  _backpack_backpackstyle3_FILL_handle_top: 'backpack/backpackstyle3/FILL-handle-top',
  _game_assets_PATTERNS_btn_outline: 'game-assets/PATTERNS_btn_outline',
  _game_assets_PATTERNS_button_9: 'game-assets/PATTERNS_button+9',
  _game_assets_PATCH_1: 'game-assets/PATCH+1',
  _game_assets_PATCH_2: 'game-assets/PATCH+2',
  _game_assets_PATTERNS_button_10: 'game-assets/PATTERNS_button+10',
  _game_assets_PATCH_3: 'game-assets/PATCH+3',
  _game_assets_PATTERNS_button_11: 'game-assets/PATTERNS_button+11',
  _game_assets_BUTTON_menu: 'game-assets/BUTTON_menu',
  _game_assets_PATCH_4: 'game-assets/PATCH+4',
  _more_assets_IntroPath_2: 'more-assets/IntroPath+2',
  _game_assets_PATCH_5: 'game-assets/PATCH+5',
  _game_assets_PATCH_6: 'game-assets/PATCH+6',
  _game_assets_PATCH_7: 'game-assets/PATCH+7',
  _game_assets_PATCH_8: 'game-assets/PATCH+8',
  _game_assets_PATCH_9: 'game-assets/PATCH+9',
  _game_assets_PATCH_10: 'game-assets/PATCH+10',
  _game_assets_PATCH_11: 'game-assets/PATCH+11',
  _game_assets_PATCH_12: 'game-assets/PATCH+12',
  _game_assets_PATCH_13: 'game-assets/PATCH+13',
  _game_assets_PATCH_14: 'game-assets/PATCH+14',
  _game_assets_PATCH_15: 'game-assets/PATCH+15',
  _game_assets_PATCH_16: 'game-assets/PATCH+16',
  _backpack_backpackstyle3_OUTLINE_handle_top: 'backpack/backpackstyle3/OUTLINE-handle-top',
  _game_assets_PATCH_17: 'game-assets/PATCH+17',
  _backpack_backpackstyle3_FILL_handle_right_bottom: 'backpack/backpackstyle3/FILL-handle-right-bottom',
  _game_assets_PATCH_18: 'game-assets/PATCH+18',
  _backpack_backpackstyle4_FILL_pocket_left: 'backpack/backpackstyle4/FILL_pocket_left',
  _game_assets_PATCH_19: 'game-assets/PATCH+19',
  _game_assets_PATCH_20: 'game-assets/PATCH+20',
  _game_assets_PATCH_21: 'game-assets/PATCH+21',
  _game_assets_PATCH_22: 'game-assets/PATCH+22',
  _backpack_backpackstyle4_FILL_pocket_right: 'backpack/backpackstyle4/FILL_pocket_right',
  _game_assets_PATCH_23: 'game-assets/PATCH+23',
  _game_assets_COLOR_fill_3: 'game-assets/COLOR_fill+3',
  _game_assets_PATCH_24: 'game-assets/PATCH+24',
  _game_assets_PATCH_25: 'game-assets/PATCH+25',
  _game_assets_PATCH_26: 'game-assets/PATCH+26',
  _game_assets_COLOR_fill_4: 'game-assets/COLOR_fill+4',
  _game_assets_COLOR_fill_5: 'game-assets/COLOR_fill+5',
  _backpack_backpackstyle3_OUTLINE_patch_left: 'backpack/backpackstyle3/OUTLINE_patch_left',
  _backpack_backpackstyle3_OUTLINE_patch_right: 'backpack/backpackstyle3/OUTLINE_patch_right',
  _backpack_backpackstyle3_FILL_patch_left: 'backpack/backpackstyle3/FILL_patch_left',
  _backpack_backpackstyle3_FILL_patch_right: 'backpack/backpackstyle3/FILL_patch_right',
}